import { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import { appReducer, initialState } from './reducer';

/**
 * Context responsible for connecting global app state with React components
 */
export const AppContext = createContext(initialState);

/**
 * Returns the global app state provider (just like Redux provider)
 * @param {*} props Props passed to this component
 * @param {React.ReactComponentElement} props.children Child component passed to the provider
 * @returns {React.ReactNode} The global app state context provider
 */
const AppContextProvider = props => {
	const [globalState, dispatch] = useReducer(appReducer, initialState);

	return (
		<AppContext.Provider value={{ globalState, dispatch }}>
			{props.children}
		</AppContext.Provider>
	);
};

AppContextProvider.propTypes = {
	children: PropTypes.element.isRequired,
};

export default AppContextProvider;
